import {create} from 'zustand';
import {normalizeGr8Path} from './gr8-web.utils';

type SportsIframeState = {
  desiredPath: string;
  requested: boolean;
  visible: boolean;
};

type SportsIframeActions = {
  destroy: () => void;
  hide: () => void;
  preload: () => void;
  show: (path?: string) => void;
};

export const useSportsIframeStore = create<
  SportsIframeState & SportsIframeActions
>(set => ({
  desiredPath: '/',
  requested: false,
  visible: false,
  destroy: () => set({requested: false, visible: false}),
  hide: () => set({visible: false}),
  preload: () => set({requested: true}),
  show: path =>
    set({
      desiredPath: normalizeGr8Path(path),
      requested: true,
      visible: true,
    }),
}));
